/**
 * Whether the navigation shelf is mid-resize (pin / unpin). Size observers hold back their updates
 * while it runs, then take one measurement when it ends, so charts re-render once, not on every frame.
 */
let active = false;
const listeners = new Set<() => void>();

export const isNavTransitioning = (): boolean => active;

export const setNavTransitioning = (next: boolean): void => {
  if (active === next) return;
  active = next;
  if (!next) listeners.forEach((listener) => listener());
};

/** Calls `listener` each time a nav transition ends; returns the unsubscribe. */
export const onNavTransitionEnd = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
